import styled from 'styled-components'

import { ButtonGroupMargin } from './ButtonGroupProps'

export const Group = styled.div<{ margin: `${ButtonGroupMargin}` }>`
  display: inline-flex;
  gap: ${(p) => (p.margin == ButtonGroupMargin.BIG ? '30px' : '12px')};
  align-items: center;
`
